import React, {ReactNode} from 'react';
import Box from '@material-ui/core/Box';
import {Guideline} from '@epic-ui/icons';
import {withStyles} from '@material-ui/core';

import {Tooltip} from '../../../../../components';

const StyledIconWrapper = withStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        margin: theme.spacing(0, 1.5),

        '& svg': {
            fill: theme.palette.text.primary,
            height: '20px'
        }
    }
}))(Box);

const SummaryItemLabel = ({children, tooltip}: {children: ReactNode; tooltip: string}) => {
    return (
        <>
            {children}
            <Tooltip placement="right" title={tooltip}>
                <StyledIconWrapper>
                    <Guideline />
                </StyledIconWrapper>
            </Tooltip>
        </>
    );
};

export default SummaryItemLabel;
